import "../../css/home.css";
import tracking1 from "../../img/ico-6.svg";
import tracking4 from "../../img/ico1.svg";
import tracking3 from "../../img/ico-3.svg";
import tracking2 from "../../img/ico-7.svg";

const ShippingSection = () => {
  return (
    <div className="container shipping-content">
      <div className="shipping-title d-flex flex-column align-items-center">
        <h3>DẪN ĐẦU VỀ GIẢI PHÁP LOGISTICS TOÀN DIỆN</h3>
        <div className="shipping-sub-title text-center">
          Chúng tôi đặt khách hàng làm trọng tâm, theo đuổi chất lượng dịch vụ
          vượt trội bằng sự chuyên nghiệp, chính trực và tinh thần không ngừng
          vươn tới sự xuất sắc, vượt xa kỳ vọng
        </div>
      </div>
      <div className="row">
        <div className="shipping-item col-md-6">
          <div className="item-box">
            <div className="item-icon">
              <img src={tracking1} alt="Tracking Icon" />
            </div>
            <div className="item-title">Vận chuyển quốc tế Trung - Việt</div>
            <div className="item-description">
              <p>
                Kết nối trực tiếp với mạng lưới ZTO toàn cầu, cam kết thời gian
                vận chuyển nhanh chóng, thủ tục đơn giản.
              </p>
            </div>
          </div>
        </div>
        <div className="shipping-item col-md-6">
          <div className="item-box">
            <div className="item-icon">
              <img src={tracking2} alt="Tracking Icon" />
            </div>
            <div className="item-title">Vận chuyển nội địa siêu tốc</div>
            <div className="item-description">
              <p>
                Phủ sóng toàn quốc với các tuyến giao nhanh trong ngày, đặc biệt
                là tuyến Hà Nội - TP.HCM - Hà Nội.
              </p>
            </div>
          </div>
        </div>
        <div className="shipping-item col-md-6">
          <div className="item-box">
            <div className="item-icon">
              <img src={tracking3} alt="Tracking Icon" />
            </div>
            <div className="item-title">TTH Nhân dân tệ</div>
            <div className="item-description">
              <p>
                Hỗ trợ khách hàng giao dịch an toàn, nhanh chóng với nhà cung
                cấp Trung Quốc.
              </p>
            </div>
          </div>
        </div>
        <div className="shipping-item col-md-6">
          <div className="item-box">
            <div className="item-icon">
              <img src={tracking4} alt="Tracking Icon" />
            </div>

            <div className="item-title">Fulfillment</div>
            <div className="item-description">
              <p>
                Nhận - lưu trữ - đóng gói - giao hàng - thu hộ - đối soát. Giúp
                shop và doanh nghiệp TMĐT vận hành hiệu quả hơn bao giờ hết.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingSection;
